var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuciDarkLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_236",
    "data-name": "Group 236",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.765,
    height: 26.5,
    viewBox: "0 0 107.765 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 107.765,
    height: 26.5,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M29.887,3.828a.6.6,0,0,0,.422-.175L33.961,0H26.844a.6.6,0,0,0-.423.175L24.01,2.588a.6.6,0,0,1-.845,0L20.753.176A.6.6,0,0,0,20.33,0H13.213l3.652,3.652a.6.6,0,0,0,.423.175Z",
    transform: "translate(-10.439)",
    fill: "#00d744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M17.832,107.987a.6.6,0,0,0-.423.175l-3.652,3.652h7.117a.6.6,0,0,0,.423-.175l2.411-2.411a.6.6,0,0,1,.845,0l2.412,2.412a.6.6,0,0,0,.423.175h7.117l-3.652-3.652a.6.6,0,0,0-.423-.175Z",
    transform: "translate(-10.869 -85.315)",
    fill: "#00d744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M108.047,30.251a.6.6,0,0,0,.175.423l3.652,3.652V27.208a.6.6,0,0,0-.175-.423l-2.411-2.411a.6.6,0,0,1,0-.845l2.412-2.412a.6.6,0,0,0,.175-.423V13.577h0l-3.652,3.652a.6.6,0,0,0-.175.423Z",
    transform: "translate(-85.362 -10.726)",
    fill: "#00d744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M3.828,17.923a.6.6,0,0,0-.175-.423L0,13.849v7.117a.6.6,0,0,0,.175.423L2.588,23.8a.6.6,0,0,1,0,.845L.176,27.057A.6.6,0,0,0,0,27.48V34.6H0l3.652-3.652a.6.6,0,0,0,.175-.423Z",
    transform: "translate(0 -10.941)",
    fill: "#00d744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M225.4,57.226a4.168,4.168,0,0,1-2.173-.562,3.745,3.745,0,0,1-1.463-1.633,5.9,5.9,0,0,1-.519-2.6V46.517a.517.517,0,0,1,.148-.382.491.491,0,0,1,.36-.148H224a.508.508,0,0,1,.53.53v5.789q0,2.375,2.078,2.375a2.055,2.055,0,0,0,1.58-.625,2.466,2.466,0,0,0,.583-1.75V46.517a.508.508,0,0,1,.53-.53h2.248a.492.492,0,0,1,.36.148.517.517,0,0,1,.148.382v9.966a.516.516,0,0,1-.148.382.491.491,0,0,1-.36.148h-2.078a.508.508,0,0,1-.53-.53v-.827a3.577,3.577,0,0,1-1.421,1.166,5.027,5.027,0,0,1-2.121.4",
    transform: "translate(-174.794 -36.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M286.548,56.428a6.157,6.157,0,0,1-2.725-.573,4.405,4.405,0,0,1-1.855-1.665,5.3,5.3,0,0,1-.742-2.619q-.021-.339-.021-.859t.021-.859a5.407,5.407,0,0,1,.732-2.64,4.326,4.326,0,0,1,1.855-1.665,6.225,6.225,0,0,1,2.735-.573,6.615,6.615,0,0,1,2.417.392,5.114,5.114,0,0,1,1.633.986,4.168,4.168,0,0,1,.944,1.241,3.034,3.034,0,0,1,.329,1.134.442.442,0,0,1-.138.371.508.508,0,0,1-.371.159h-2.269a.444.444,0,0,1-.329-.117,1.253,1.253,0,0,1-.223-.329,2.248,2.248,0,0,0-.763-1.06,2.025,2.025,0,0,0-1.167-.318,1.921,1.921,0,0,0-1.506.615,2.949,2.949,0,0,0-.594,1.908q-.021.827,0,1.505a3.009,3.009,0,0,0,.6,1.908,1.919,1.919,0,0,0,1.495.594,2,2,0,0,0,1.188-.318,2.318,2.318,0,0,0,.742-1.06.881.881,0,0,1,.212-.329.483.483,0,0,1,.339-.117h2.269a.509.509,0,0,1,.371.159.442.442,0,0,1,.138.371,3.026,3.026,0,0,1-.2.848,3.825,3.825,0,0,1-.572,1,4.642,4.642,0,0,1-1.007.944,5.147,5.147,0,0,1-1.495.7,7.131,7.131,0,0,1-2.046.265",
    transform: "translate(-222.165 -35.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M340.978,30.489a.49.49,0,0,1-.36-.148.515.515,0,0,1-.148-.382v-1.7a.553.553,0,0,1,.148-.392.474.474,0,0,1,.36-.159H343.2a.544.544,0,0,1,.551.551v1.7a.5.5,0,0,1-.159.382.553.553,0,0,1-.392.148Z",
    transform: "translate(-268.986 -21.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M341.281,57.014a.489.489,0,0,1-.36-.148.515.515,0,0,1-.148-.382V46.518a.516.516,0,0,1,.148-.382.491.491,0,0,1,.36-.148H343.4a.509.509,0,0,1,.53.53v9.966a.509.509,0,0,1-.53.53Z",
    transform: "translate(-269.226 -36.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M365.041,41.854a.438.438,0,0,1-.467-.467V27.265a.438.438,0,0,1,.467-.466h.36a.438.438,0,0,1,.467.466v5.026a4.651,4.651,0,0,1,1.389-1.209,5.1,5.1,0,0,1,4.58.159,3.84,3.84,0,0,1,1.442,1.7,5.907,5.907,0,0,1,.477,2.428v6.022a.437.437,0,0,1-.466.467h-.361a.438.438,0,0,1-.466-.467V35.472a3.959,3.959,0,0,0-.827-2.661,3.009,3.009,0,0,0-2.417-.965,3.205,3.205,0,0,0-2.428.965,3.693,3.693,0,0,0-.922,2.661v5.916a.438.438,0,0,1-.467.467Z",
    transform: "translate(-288.03 -21.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M421,57.226a4.231,4.231,0,0,1-2.385-.626,3.739,3.739,0,0,1-1.4-1.707,6.163,6.163,0,0,1-.456-2.417V46.454a.438.438,0,0,1,.467-.467h.36a.438.438,0,0,1,.466.467V52.37q0,3.626,3.16,3.626a3.17,3.17,0,0,0,2.417-.965,3.72,3.72,0,0,0,.912-2.661V46.454a.438.438,0,0,1,.466-.467h.361a.438.438,0,0,1,.466.467V56.547a.438.438,0,0,1-.466.467h-.361a.438.438,0,0,1-.466-.467v-1a4.742,4.742,0,0,1-1.368,1.209,4.3,4.3,0,0,1-2.173.467",
    transform: "translate(-329.257 -36.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M473.29,42.065a4.436,4.436,0,0,1-2.173-.477,4.256,4.256,0,0,1-1.389-1.2v1a.438.438,0,0,1-.466.467H468.9a.438.438,0,0,1-.466-.467V27.265a.438.438,0,0,1,.466-.467h.361a.438.438,0,0,1,.466.467V32.29a4.5,4.5,0,0,1,1.389-1.187,4.356,4.356,0,0,1,2.173-.488,4.479,4.479,0,0,1,2.1.445,3.882,3.882,0,0,1,1.378,1.187,5.26,5.26,0,0,1,.785,1.654,7.488,7.488,0,0,1,.276,1.845q.021.318.021.594t-.021.594a7.485,7.485,0,0,1-.276,1.845,5.252,5.252,0,0,1-.785,1.654,3.881,3.881,0,0,1-1.378,1.187,4.479,4.479,0,0,1-2.1.445m-.127-1.23a3.172,3.172,0,0,0,1.972-.551,3.072,3.072,0,0,0,1.039-1.442,6.439,6.439,0,0,0,.36-1.908q.021-.593,0-1.187a6.441,6.441,0,0,0-.36-1.908,3.074,3.074,0,0,0-1.039-1.442,3.708,3.708,0,0,0-3.891,0,3.423,3.423,0,0,0-1.124,1.378,4.319,4.319,0,0,0-.392,1.675q-.021.318-.021.827t.021.827a5.228,5.228,0,0,0,.392,1.728,3.4,3.4,0,0,0,1.092,1.431,3.107,3.107,0,0,0,1.951.573",
    transform: "translate(-370.084 -21.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M42.191,41.794V27.411a.368.368,0,0,0-.368-.368H27.44a.368.368,0,0,0-.368.368V41.794a.368.368,0,0,0,.368.368H41.823a.368.368,0,0,0,.368-.368m-2.469-4.943A5.6,5.6,0,1,1,40.2,34.59a5.624,5.624,0,0,1-.477,2.262",
    transform: "translate(-21.388 -21.365)",
    fill: "#21d644"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M163.229,42.651a.508.508,0,0,1-.53-.53V28.338a.508.508,0,0,1,.53-.53h2.354a.508.508,0,0,1,.53.53V39.81h6.573a.508.508,0,0,1,.53.53v1.781a.508.508,0,0,1-.53.53Z",
    transform: "translate(-128.54 -21.97)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuciDarkLogo);
export default __webpack_public_path__ + "static/media/luci_dark_logo.61490b933230a4dfbd96fbe1f1d7cd1d.svg";
export { ForwardRef as ReactComponent };